import React from 'react'
import cn from 'classnames'
import LegacyLink from 'components/LegacyLink'
import { Flex, BoxHeadline, Button, SUI } from 'shared/ui'

const NotFound = ({ className, text, linkText, to }) => {
  return (
    <Flex
      className={cn(
        'grui my-20 mx-10 items-center justify-center flex-col',
        className
      )}
    >
      <div>
        <BoxHeadline>{text}</BoxHeadline>
      </div>
      <div className="grui mt-4">
        <SUI>
          <Button
            size="medium"
            primary
            path={to}
            as={LegacyLink}
            target="_blank"
          >
            {linkText}
          </Button>
        </SUI>
      </div>
    </Flex>
  )
}

export default NotFound
